import { FileData, STATUS_FILE } from '@/hooks/useHelpfindUploady';

const IMAGE_EXTENSIONS = ['jpg', 'jpeg', 'png', 'heic'];

const getExtension = (name: string) =>
  name.split('.').pop()?.toLowerCase() ?? '';

// FE-5375: a single photo is never a complete estimate (min. 2 pages),
// a PDF or an archive is assumed complete
export const isInsurersEstimateIncomplete = (
  files: Pick<FileData, 'name' | 'status'>[]
) => {
  const finished = files.filter((i) => i.status === STATUS_FILE.FINISHED);
  return (
    finished.length === 1 &&
    IMAGE_EXTENSIONS.includes(getExtension(finished[0].name))
  );
};
